import Pagination from '@Components/Common/Pagination';
import { ColumnType, DynamicTable } from '@Components/General/DynamicTable';
import { Box, Link, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { DisplayName } from '@Components/General/DynamicTable/Cells';
import ItemsPerPage from '@Components/General/ItemsPerPage';
import { Link as RouterLink, useNavigate } from '@tanstack/react-router';

// TODO: Implement shift select

const ExpenseId = ({ row }) => {
    return (
        <Link
            variant="bodyLarge"
            component={RouterLink}
            to={`${row.expense_id}`}
        >
            {row.expense_id}
        </Link>
    );
};

const TableHeader = ({ count, pageSize, setPageSize }) => {
    const { t } = useTranslation();
    return (
        <Box display="flex" justifyContent="space-between" alignItems="center">
            <Typography>{`${count.toLocaleString()} ${t(
                'Expenses',
            )}`}</Typography>
            <ItemsPerPage
                label={t('Expenses')}
                pageSize={pageSize}
                onChange={setPageSize}
            />
        </Box>
    );
};

function ExpensesTable({
    expenses,
    pageCount,
    page,
    setPage,
    pageSize,
    setPageSize,
    count,
    getSort,
    onSortChange,
    checkedExpenses,
    setCheckedExpenses,
    toggleCheckItem,
    additionalColumns = [],
}) {
    const { t } = useTranslation();
    // const location = useLocation();
    const navigate = useNavigate();

    // useEffect(() => {
    //     if (location.hash) {
    //         const element = document.getElementById(location.hash.slice(1));
    //         if (element) {
    //             element.scrollIntoView();
    //         }
    //     }
    // }, [location.hash]);

    const columns: ColumnType = [
        {
            name: t('Number'),
            field: 'expense_id',
            Component: ExpenseId,
        },
        {
            name: t('Donor'),
            sortField: 'name',
            field: 'donor',
            Component: DisplayName,
            contactIdField: 'donor.contact_id',
            nameField: 'donor.display_name',
        },
        {
            name: t('Date'),
            sortField: 'expense_date',
            field: 'expense_date',
            componentType: 'date',
        },
        {
            name: t('Expense Type'),
            sortField: 'expense_type',
            field: 'expense_type',
        },
        {
            name: t('Amount'),
            sortField: 'amount',
            field: 'expense_amount',
            componentType: 'currency_amount',
        },
        {
            name: t('Payments'),
            sortField: 'payments',
            field: 'expense_payments',
        },
        {
            name: t('Fundraiser'),
            sortField: 'fundraiser',
            field: 'fundraiser',
            Component: DisplayName,
            contactIdField: 'fundraiser.contact_id',
            nameField: 'fundraiser.display_name',
        },
        {
            name: t('Notes'),
            sortField: 'donor_note',
            field: 'donor_note',
        },
        ...additionalColumns,
    ];

    return (
        <>
            <DynamicTable
                {...(pageSize
                    ? {
                          tableHeader: (
                              <TableHeader
                                  pageSize={pageSize}
                                  setPageSize={setPageSize}
                                  count={count}
                              />
                          ),
                      }
                    : {})}
                columns={columns}
                rows={expenses || []}
                checkField="expense_id"
                checkedRows={checkedExpenses}
                setCheckedRows={setCheckedExpenses}
                toggleCheck={toggleCheckItem}
                getSort={getSort}
                onSortChange={onSortChange}
                rowProps={row => ({
                    onClick: () =>
                        navigate({ to: `/expenses/${row.expense_id}` }),
                })}
            />
            <Pagination
                sx={{ mt: '2rem' }}
                pageCount={pageCount}
                page={page}
                onChange={setPage}
            />
        </>
    );
}

export default ExpensesTable;
